import { getStopStatusIcon } from '../app/components/StopStatusIcon/stopStatusIcon.js';

App.Views = App.Views || {};
App.Models = App.Models || {};
App.Collections = App.Collections || {};
App.Routers = App.Routers || {};
App.Templates = App.Templates || {};
App.Forms = App.Forms || {};
App.Version = App.Version || {};
App.Objects = App.Objects || {};

if (typeof Greenmile === 'undefined') {
  Greenmile = {
    Session: {
      Configurations: {
        MapConfiguration: {}
      }
    }
  };
}

App.MakeLayouts = {
  screenConfigurationFunctions: function () {
    $('.sideBarNewWindow').on('click', function () {
      window.location = '#/RouteSummary';
    });

    $('.icon_new_window').off('click');

    $('.icon_new_window').on('click', function () {
      window.location = '#/RouteSummary';
    });

    if (Monet.Session.mainMap && Monet.Session.mainMap.map !== '') {
      let timeOut = null;

      timeOut = setTimeout(function () {
        if (Monet.Session.mainMap?.map) {
          Monet.Session.mainMap.map.invalidateSize();
        }
        clearTimeout(timeOut);
      }, 400);
    }
  },

  mapScreenConfiguration: function () {
    $(function () {
      App.MakeLayouts.screenConfigurationFunctions();
    });

    $(window).off('resize', function () {
      App.MakeLayouts.screenConfigurationFunctions();
    });

    $(window).on('resize', function () {
      App.MakeLayouts.screenConfigurationFunctions();
    });
  }
};

Greenmile.Platform = {
  userAgent: '',
  platform: '',
  browser: {
    language: '',
    version: '',
    name: ''
  },

  check: function () {
    this.userAgent = navigator.userAgent;
    this.browser.name = this.extractBrowserInformations();
    this.browser.version = this.extractBrowserVersion();

    if (this.browser.name === 'MSIE') {
      this.browser.language = navigator.browserLanguage;
      this.isIE = true;
    } else {
      this.browser.language = navigator.language;
    }
  },

  extractBrowserInformations: function () {
    const safari = this.userAgent.indexOf('Safari');
    const firefox = this.userAgent.indexOf('Firefox');
    const ie =
      this.userAgent.indexOf('MSIE') !== -1 ||
      this.userAgent.indexOf('Trident') !== -1;
    const chrome = this.userAgent.indexOf('Chrome');

    if (firefox > 0) {
      return 'Firefox';
    }

    if (ie > 0) {
      return 'MSIE';
    }

    if (chrome > 0) {
      return 'Chrome';
    }

    if (safari > 0) {
      return 'Safari';
    }
  },

  extractBrowserVersion: function () {
    var version = [];
    var that = this;
    var validationFunctions = {
      Safari: function () {
        version = that.userAgent.match(/Safari\/(.+?)$/);

        if (version[1]) {
          return version[1].trim();
        }
      },
      Firefox: function () {
        version = that.userAgent.match(/Firefox\/(.+?)$/);

        if (version[1]) {
          return version[1].trim();
        }
      },
      MSIE: function () {
        version = that.userAgent.match(/MSIE(.+?)\;/);

        if (!version) {
          version = that.userAgent.match(/rv:([0-9].?)/);

          if (version) {
            return version[1].trim();
          }
        } else if (version[1]) {
          return version[1].trim();
        }
      },
      Chrome: function () {
        version = that.userAgent.match(/Chrome\/(.+?) Safari/);

        if (version[1]) {
          return version[1].trim();
        }
      }
    };

    var functionToBrowser = validationFunctions[this.browser.name];
    var result = '?';
    if (functionToBrowser) {
      result = validationFunctions[this.browser.name]();
    }

    return result;
  }
};

/*
 * Esse objeto serve apenas como namespace para guardar coisas que deveriam ser globais
 * algumas dessas informações são usadas também para guardar estado de elementos da interface
 * como a ordenação do grid, por exemplo, antes de ele ser remontado a cada atualização
 * de dados.
 *
 * O desenvolvedor deve adicionar os objetos seguindo a estrutura das telas, exemplo:
 *
 * é para a ba de mapas:
 *
 *
 */

Monet.Session = {
  sessionStorage: {
    setItem: function (key, value) {
      this[key] = value;
    },
    getItem: function (key) {
      return this[key];
    },
    clear: function () {
      for (var key in this) {
        if (key !== 'setItem' && key !== 'getItem' && key !== 'clear') {
          delete this[key];
        }
      }
    }
  },
  Grids: {
    Route: {
      indexes: {},
      layout: [],
      layoutCompact: [],
      indexesCompact: {},
      status: undefined,
      data: undefined,
      height: undefined,
      table: undefined,
      tableCompact: undefined,
      needAjust: true,
      firstTime: true,
      first: 0,
      max: 101,
      total: 0,
      blocked: false,
      sort: []
    },
    RouteSummary: {
      indexes: {},
      layout: [],
      layoutCompact: [],
      indexesCompact: {},
      status: undefined,
      data: undefined,
      height: undefined,
      table: undefined,
      tableCompact: undefined,
      needAjust: true,
      firstTime: true,
      first: 0,
      max: 101,
      total: 0,
      blocked: false,
      sort: []
    },
    Stop: {
      indexes: {},
      layout: [],
      status: undefined,
      data: undefined,
      height: undefined,
      table: undefined,
      needAjust: true,
      parentRoute: undefined,
      first: 0,
      max: 101,
      total: 0,
      blocked: false,
      sort: []
    },
    Order: {
      indexes: {},
      layout: [],
      status: undefined,
      data: undefined,
      height: undefined,
      table: undefined,
      needAjust: true,
      parentRoute: undefined,
      first: 0,
      max: 101,
      total: 0,
      blocked: false,
      sort: []
    },
    LineItems: {
      indexes: {},
      layout: [],
      status: undefined,
      data: undefined,
      height: undefined,
      table: undefined,
      needAjust: true,
      parentRoute: undefined,
      first: 0,
      max: 101,
      total: 0,
      blocked: false,
      sort: []
    }
  },

  RouteDetail: {
    screensList: {}
  },
  UserPreferences: {}
};

/*
 * Armazena os retorno do setTimeout() e setInterval() de maneira global
 * para poder cancelar depois.
 */

Monet.Session.Notification = {
  timeout: undefined,
  interval: undefined
};

Monet.Session.WindowNotification = {
  selector: undefined
};

Monet.Session.UrgentEventList = {
  selector: null,
  canUpdate: true
};

/* Greenmile Utils */

Greenmile.Utils = Greenmile.Utils || {};

/**
 * Jamaica
 * @param model - route
 * @returns {*}
 */

Greenmile.Utils.filterFromInfoMarkerTruck = function (model, str) {
  const infoMarkerTruckFromSessionStorage =
    Monet.Session.sessionStorage.getItem('infoMarkerTruck');

  if (infoMarkerTruckFromSessionStorage) {
    const infoMarkerTruck = JSON.parse(infoMarkerTruckFromSessionStorage),
      key = infoMarkerTruck[model.organization.id],
      driverAssignment = model.driverAssignments
        ? model.driverAssignments[0]
        : null;

    switch (key) {
      case 'EQUIPMENT':
        if (model.principalEquipment) {
          str = model.principalEquipment;
        }
        break;
      case 'DRIVER':
        if (driverAssignment) {
          str =
            driverAssignment.driver.key + ' - ' + driverAssignment.driver.name;
        }
        break;
      case 'DRIVER_NAME':
        if (driverAssignment) {
          str = driverAssignment.driver.name;
        }
        break;
      case 'DRIVER_KEY':
        if (driverAssignment) {
          str = driverAssignment.driver.key;
        }
        break;
      case 'ROUTE_DRIVER_NAME':
        if (driverAssignment) {
          str = model.key + ' - ' + driverAssignment.driver.name;
        }
        break;
      default:
        str = model.key;
        break;
    }
  }

  return str;
};

Greenmile.Utils.gridRouteProgressBar = function (model, infoMarkerTruck) {
  const routeProgressBar = new Greenmile.Components.RouteProgressBar();
  const divRouteProgressBar = document.createElement('div');
  const template = document.createElement('div');
  divRouteProgressBar.className = 'routeMonitorRouteItem';
  template.className = 'menuContainerRouteProperties';

  const routeKey = infoMarkerTruck
    ? Greenmile.Utils.filterFromInfoMarkerTruck(model, model.key)
    : model.key;

  const routeDate = model.date;
  const formattedDate = Monet.Format.Date.formatToLocale(routeDate);

  const routeName = document.createElement('div');
  const divRouteDate = document.createElement('div');

  routeName.className = 'routeName';
  divRouteDate.className = 'routeDate';

  routeName.innerHTML = routeKey;
  routeName.setAttribute('title', routeKey);
  divRouteDate.innerHTML = formattedDate;
  divRouteProgressBar.appendChild(routeProgressBar.createProgressBar(model));

  template.appendChild(routeName);
  template.appendChild(divRouteDate);
  template.appendChild(divRouteProgressBar);

  return template.outerHTML;
};

Greenmile.Utils.renderRouteStatus = function (model) {
  // NOT_STARTED, STARTED, DEPARTED_ORIGIN, ARRIVED_ORIGIN, COMPLETED

  let status = model.status;
  const totalEventLogs = model.totalEventLogs;
  let totalStopsInProgress = model.totalStopsInProgress;
  let display = 'display:block';
  const i18n = Monet.I18n;

  if (!status) {
    status = 'NOT_STARTED';
  }

  if (totalStopsInProgress > 0) {
    status = 'WITH_STOP_IN_PROGRESS';
  }

  const getEventsInfo = function () {
    if (typeof totalEventLogs === 'undefined') {
      display = 'display:none';
    } else if (totalEventLogs === 0) {
      display = 'visibility:hidden';
    }

    return (
      '<div class="totalEventLogs" style=' +
      display +
      '>' +
      totalEventLogs +
      '</div>'
    );
  };

  const statusAndClasses = {
    NOT_STARTED: {
      title: 'Greenmile.Route.IconDescription.notStarted',
      clazz: 'routeStatusNotLoaded'
    },
    STARTED: {
      title: 'Greenmile.Route.IconDescription.started',
      clazz: 'routeStatusLoadedButNoStarted'
    },
    DEPARTED_ORIGIN: {
      title: 'Greenmile.Route.IconDescription.departedOrigin',
      clazz: 'routeStatusInRute'
    },
    ARRIVED_ORIGIN: {
      title: 'Greenmile.Route.IconDescription.arrivedOrigin',
      clazz: 'routeStatusBackToDepot'
    },
    COMPLETED: {
      title: 'Greenmile.Route.IconDescription.completed',
      clazz: 'routeStatusRouteComplet'
    },
    WITH_STOP_IN_PROGRESS: {
      title: 'Greenmile.Route.IconDescription.withStopsInProgress',
      clazz: 'stopsInProgress'
    }
  };

  const getIconHtml = function () {
    const statusObj = statusAndClasses[status];
    const eventInfo = getEventsInfo();
    if (statusObj) {
      return (
        (status !== 'COMPLETED' ? eventInfo : '') +
        '<div class="' +
        statusObj.clazz +
        '" title="' +
        i18n.getResourcesByKey(statusObj.title) +
        '"></div>'
      );
    }
  };

  return getIconHtml();
};

Greenmile.Utils.getResourceWithUnitMetric = function (keyResource) {
  var unitSystem = Monet.Session.User.unitSystem,
    unitSystemStr = '';

  if (unitSystem === 'NON_METRIC') {
    unitSystemStr = Monet.I18n.getResourcesByKey(
      'Greenmile.UnitMetrics.milesAbreviationParentheses'
    );
  } else {
    unitSystemStr = Monet.I18n.getResourcesByKey(
      'Greenmile.UnitMetrics.mettersAbreviationParentheses'
    );
  }

  return Monet.I18n.getResourcesByKey(keyResource, unitSystemStr);
};

Greenmile.Utils.getListRouteTags = function () {
  const startRoute = {
    description: 'route.StartRoute',
    value: 'START_ROUTE'
  };

  const departDestination = {
    description: 'route.DepartOrigin',
    value: 'DEPART_ORIGIN'
  };

  const arriveDestination = {
    description: 'route.ArriveDestination',
    value: 'ARRIVE_DESTINATION'
  };

  const completeRoute = {
    description: 'route.CompleteRoute',
    value: 'COMPLETE_ROUTE'
  };

  const createRoute = {
    description: 'route.createdRoute',
    value: 'CREATE_ROUTE'
  };

  const tags = [];

  tags.push(startRoute);
  tags.push(departDestination);
  tags.push(arriveDestination);
  tags.push(completeRoute);
  tags.push(createRoute);

  return tags;
};

Greenmile.Utils.getOperators = function (dataType) {
  const operators = [];

  const empty = {
    description: Monet.I18n.getResourcesByKey(
      'tag.label.selectAConditionPlaceholder'
    ),
    value: ''
  };

  const equal = {
    description: 'operator.equal',
    value: 'eq'
  };

  const notEqual = {
    description: 'operator.notEqual',
    value: 'neq'
  };

  operators.push(empty);
  operators.push(equal);
  operators.push(notEqual);

  if (dataType === 'number') {
    const lessThan = {
      description: 'operator.lessThan',
      value: 'lt'
    };

    const lessThanEqual = {
      description: 'operator.lessThanEqual',
      value: 'lte'
    };

    const greaterThan = {
      description: 'operator.greaterThan',
      value: 'gt'
    };

    const greaterThanEqual = {
      description: 'operator.greaterThanEqual',
      value: 'gte'
    };

    operators.push(lessThan);
    operators.push(lessThanEqual);
    operators.push(greaterThan);
    operators.push(greaterThanEqual);
  }

  if (dataType === 'text') {
    const contains = {
      description: 'operator.contains',
      value: 'contains'
    };

    const operatorIn = {
      description: 'operator.in',
      value: 'in'
    };

    operators.push(operatorIn);
    operators.push(contains);
  }

  return operators;
};

Greenmile.Utils.getListStopTags = function () {
  //    ARRIVE_STOP
  //    DEPART_STOP
  //    CANCEL_STOP
  //    UNDELIVERABLE_STOP
  //    REDELIVERY

  var arriveStop = {
    description: 'stop.ArriveStop',
    value: 'ARRIVE_STOP'
  };

  var departStop = {
    description: 'stop.DepartStop',
    value: 'DEPART_STOP'
  };

  var cancelStop = {
    description: 'stop.CancelStop',
    value: 'CANCEL_STOP'
  };

  var undeliverableStop = {
    description: 'stop.UndeliverableStop',
    value: 'UNDELIVERABLE_STOP'
  };

  var redeliveryStop = {
    description: 'stop.RedeliveryStop',
    value: 'REDELIVERY'
  };

  var tags = [];

  tags.push(arriveStop);
  tags.push(departStop);
  tags.push(cancelStop);
  tags.push(undeliverableStop);
  tags.push(redeliveryStop);

  return tags;
};

Greenmile.Utils.StopRadius = function () {
  this.tab = Monet.Utils.GetTabName();
  this.routeId = parseInt(this.tab.replace('routeMaps_', ''), 10);
  this.map = Monet.Session.RouteDetail.screensList[this.routeId].map;

  this.create = function () {
    var stops = Monet.Session.RouteDetail.screensList[this.routeId].stops.data;

    for (var i = 0; i < stops.size(); i++) {
      var lat = stops.at(i).get('location').latitude;
      var lng = stops.at(i).get('location').longitude;

      var circle = L.circle([lat, lng], 200, {
        color: 'blue',
        fillColor: '#144AC7',
        fillOpacity: 0.3
      });

      circle.kind = 'DEBUG_RADIUS';
      circle.addTo(this.map);
    }
  };

  this.clear = function () {
    var layers = this.map._layers;

    for (var layer in layers) {
      if (layers[layer].kind === 'DEBUG_RADIUS') {
        this.map.removeLayer(layers[layer]);
      }
    }
  };
};

Greenmile.Utils.hasPermission = (featureName) => {
  featureName =
    featureName === 'PRO' ? 'PROACTIVE_ROUTE_OPTIMIZATION' : featureName;
  const { featureStates } = Monet.Session.ApplicationLoad;
  return featureStates?.some(
      (feature) => feature.name == featureName && feature.enabled
    );
};

Greenmile.Utils.hasResequenceHistoryPermission = function () {
  const PROFeatureEnabled = Greenmile.Utils.hasPermission('PRO');
  return (
    PROFeatureEnabled &&
    Monet.Session.Security.permissions.some(
      (permission) => permission.key === 'PROACTIVEROUTEOPT_LIST'
    )
  );
};
// Import the refactored getStopStatusIcon function

Greenmile.Utils.getStopStatusIcon = getStopStatusIcon;

Greenmile.Utils.StopPlacement = {
  getDataToOption: function () {
    return {
      value: ['BEST_INSERTION', 'AFTER_STOP', 'BEFORE_STOP', 'FIRST', 'LAST'],
      showValue: [
        'stop.placement.values.bestInsertion',
        'stop.placement.values.afterStop',
        'stop.placement.values.beforeStop',
        'stop.placement.values.first',
        'stop.placement.values.last'
      ]
    };
  }
};

/**
 *
 * Generates a complete monet's layout with one section containing a searchGridLayout
 * the searchGridColumns will be populated based a projection passed as parameter plus
 * field info stored in proper namespace.
 *
 * @param entity
 * @param projection
 */
Greenmile.Utils.createGridLayoutFromProjection = {
  parse: function (entity, projection) {
    const parsedProjection = this.clearProjectionWithAsterisk(
      JSON.parse(projection)
    );
    const fields = App.Forms[entity].fields;
    const searchGridColumns = [];
    const baseMonetLayout = {
      userInterfaceAction: {
        userInterface: {
          key: entity,
          description: ''
        },
        key: 'index'
      },
      sections: [
        {
          description: ' ',
          key: 'pls_index_btn',
          layoutColumns: 1,
          layoutOrder: 1,
          sectionRelatedLists: [],
          sectionFields: [],
          sectionButtons: []
        },
        {
          key: 'pls_index_grid_' + entity.toLowerCase(),
          description: '',
          layoutColumns: 1,
          layoutOrder: 1,
          sectionRelatedLists: [
            {
              searchGridLayout: {
                entity: {
                  key: entity
                },
                description: entity,
                kind: 'DETAILED',
                searchGridColumns: [],
                searchGridActions: []
              },
              sectionOrder: 1
            }
          ],
          sectionFields: [],
          sectionButtons: []
        }
      ]
    };
    for (let i = 0, l = parsedProjection.length; i < l; i++) {
      const column = this.getFieldByProjectionPattern(i, fields, parsedProjection[i]);
      if (column) {
        searchGridColumns.push(column);
      }
    }

    baseMonetLayout.sections[1].sectionRelatedLists[0].searchGridLayout.searchGridColumns =
      searchGridColumns;

    return baseMonetLayout;
  },

  clearProjectionWithAsterisk: function (projection) {
    return projection.filters.filter(function (i) {
      return !(i.match(/\*/) || i.match('id'));
    });
  },

  getFieldByProjectionPattern: function (index, fields, projection) {
    const l = projection.length;
    for (let i = 0; i < l; i++) {
      for (const field in fields) {
        if (this.makeFieldName(fields[field]) === projection) {
          return {
            columnOrder: index,
            isSorted: false,
            isAscendent: true,
            sizePixels: 200,
            isFrozen: false,
            field: fields[field]
          };
        }
      }
    }

    return null;
  },

  makeFieldName: function (field) {
    return (
      field.name +
      (field.lookupEntityColumn ? '.' + field.lookupEntityColumn : '')
    );
  }
};

Greenmile.Utils.changeFooterAndHeaderZIndex = function () {
  const header = document.getElementById('header');
  const body = document.getElementById('content');

  header.addEventListener(
    'mouseover',
    (function (header, body) {
      return function () {
        header.style.zIndex = 9999;
        body.style.zIndex = 9;
      };
    })(header, body)
  );

  body.addEventListener(
    'mouseover',
    (function (header, body) {
      return function () {
        body.style.zIndex = 9999;
        header.style.zIndex = 9;
      };
    })(header, body)
  );
};

Greenmile.Utils.DateFieldsFunctions = {
  getFutureDateFieldName: (dateField) => {
    const fieldDateValue = dateField.value;

    if (fieldDateValue) {
      const fieldResource = dateField.field.label;
      const fieldName = Monet.I18n.getResourcesByKey(fieldResource);

      const { validateIfDateIsInFuture } = new Monet.Date.GeneralFunctions();
      const isAfter = validateIfDateIsInFuture(fieldDateValue);

      return isAfter ? fieldName : null;
    }
  },

  showFutureDatesError: ({ fieldsWithError, scope }) => {
    const errorResource = Monet.I18n.getResourcesByKey(
      'Greenmile.Form.futureDates.error'
    );

    const parsedsFieldsWithError = fieldsWithError.map((fieldErrored) => {
      const formatedError = errorResource.replace('@dateString@', fieldErrored);

      return {
        resource: {
          i18nMessage: formatedError
        }
      };
    });

    const monetMessage = new Monet.Form.Messages.InlineMessage();
    monetMessage.setScope(scope);
    monetMessage.setInfoType('error');
    monetMessage.setMessage({
      errorMessages: parsedsFieldsWithError
    });
    monetMessage.triggerMessage();
  }
};

Greenmile.Utils.getTenant = function (parseTenant = false) {
  const defaultTenant = 'lts';
  const tenant = window.location.host.match(/([a-z0-9-]+)/gi)[0];

  if (parseTenant) {
    return tenant;
  }

  return tenant === 'localhost' ? defaultTenant : tenant;
};

Greenmile.Utils.checkIfTenantIsIp = function () {
  const ipAddressRegex = /^(?:\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}):8080\b/gi;

  return ipAddressRegex.test(window.location.host);
};

Greenmile.Utils.fixGridActionsPopupsPosition = function ({
  popupElementInstance,
  buttonSelector
}) {
  const { height } = popupElementInstance.getBoundingClientRect();
  const { y } = document.querySelector(buttonSelector).getBoundingClientRect();

  if (!height || !y) return;

  const AVAILABLE_HEIGHT =
    document.querySelector('.mainContainer').clientHeight;
  const popUpHeight = AVAILABLE_HEIGHT - y;
  const marginAndPadding = 40;

  popupElementInstance.style.top = '-18px';
  popupElementInstance.style.height = `${popUpHeight - marginAndPadding}px`;
};
